import { useState } from 'react';
import { SortingState } from '@tanstack/react-table';
import { PostTypeInsights, GetSocialAnalyticsNetworksQuery } from '@frontend/gql/social/graphql';
import { QueryVariables } from '../types';
import { NetworksTableColumn } from '../components/table/config/defaultNetworksTableColumns';

interface usePostsTabProps {
  queryVariables: QueryVariables;
  setSelectedColumns: (columns: NetworksTableColumn<PostTypeInsights>[]) => void;
  selectedColumns: NetworksTableColumn<PostTypeInsights>[];
  fetching: boolean;
  data: GetSocialAnalyticsNetworksQuery;
  socialDataReconciliation?: boolean;
}

export const useNetworksTab = ({
  queryVariables,
  setSelectedColumns,
  selectedColumns,
  fetching,
  data,
  socialDataReconciliation,
}: usePostsTabProps) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isPartialLoading, setIsPartialLoading] = useState(false);
  const [sorting, setSorting] = useState<SortingState>([
    {
      desc: true,
      id: 'engagementRate',
    },
  ]);

  const handleSortingChange = (sorting: SortingState) => {
    setCurrentPage(0);
    setSorting(sorting);
  };

  return {
    networksTabProps: {
      data,
      isLoading: fetching,
      isPartialLoading: fetching && isPartialLoading,
      queryVariables,
      currentPage,
      setCurrentPage,
      sorting,
      setSorting: handleSortingChange,
      setIsPartialLoading,
      selectedColumns,
      setSelectedColumns,
      socialDataReconciliation,
    },
  };
};
